import moment from 'moment'
import config from '@/config/index'

export function api (path) {
  return config.serverURI + path
}

export function formatMediumDate (date) {
  return new Date(date).toLocaleDateString('th-u-ca-buddhist-thai', {day: '2-digit', month: 'short', year: 'numeric'})
}

export function formatShortDate (date) {
  return moment(date).format('DD/MM/YYYY')
}

export function statusBgColor (status) {
  let bgColor = ''
  switch (status) {
    case 'DRAFT':
      bgColor = 'blue'
      break
    case 'COMPLETED':
      bgColor = 'green'
      break
    case 'CANCELED':
      bgColor = 'red'
      break
    default:
      bgColor = 'grey'
  }
  return bgColor
}



// WEBPACK FOOTER //
// ./src/filters/index.js